const stagesDictionary = (stage) => {
  switch (stage) {
    case "PRINTING":
      return "impresión 3D";
    case "POLISHING":
      return "pulido";
    case "PAINTING":
      return "pintura";
    case "ASSEMBLY":
      return "ensamble";
    case "TESTING":
      return "pruebas";
    case "PACKING":
      return "empacado";
    default:
      return "desconocida";
  }
};

export const interactionsSelector = (interaction) => {
  const stageInteractions = [
    "PRINTING",
    "POLISHING",
    "PAINTING",
    "ASSEMBLY",
    "TESTING",
    "PACKING",
  ];

  if (stageInteractions.includes(interaction.value)) {
    if (interaction.action === "START_STAGE") {
      return `Etapa de ${stagesDictionary(
        interaction.value
      )} fue inicializada.`;
    } else {
      return `Etapa de ${stagesDictionary(interaction.value)} fue finalizada.`;
    }
  } else if (interaction.action === "PRODUCT_STARTED") {
    return "Se comenzó a producir.";
  } else if (interaction.action === "PRODUCT_FINISHED") {
    return "Se finalizó el producto.";
  } else if (interaction.action === "BULK_PRODUCTS_FINISHED") {
    return "Se finalizó el producto (finalización masiva de la orden).";
  } else if (interaction.action === "SERIAL_SETTED") {
    return `Se asignó identificador serial ${interaction.value}.`;
  } else if (interaction.action === "COMMOD_SETTED") {
    return `Se asignó identificador de comMod ${interaction.value}.`;
  } else {
    return "Interacción desconocida";
  }
};
